import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Avatar } from 'components/UI'
// context
import { StrategyActionsBLContext } from 'containers/StrategyActions/layers/BL'
// hooks
import { useCurrentUser } from 'hooks'
// themes
import CheckedOriginIcon from '@mui/icons-material/Check'
import { colors } from 'themes'
// utils
import pipe from 'lodash/fp/pipe'
import { generateUserName } from 'utils/user'
import { size } from 'polished'

// styled
const CheckedIcon = styled(CheckedOriginIcon)`
  margin-right: 16px;
  ${size('14px')};
  right: 0;
`

const Wrapper = styled((props) => <Grid {...props} />)`
  && {
    cursor: pointer;
    font-size: 15px;
    margin: 8px 0;
    width: 100%;

    & > :first-child {
      background-color: ${colors.gray220};
      border: none;
      color: ${colors.blue900};
      font-size: 14px;
      font-weight: 500;
      height: 35px;
      margin-right: 8px;
      margin-left: 1px;
      width: 35px;
    }

    & > input {
      display: none;
    }

    & > svg {
      margin-left: auto;
    }

    & > span {
      margin-left: 4px;
    }
  }
`

const Name = styled('div')`
  max-width: 70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const Member: React.FunctionComponent<any> = ({ user }) => {
  const [isChecked, setIsChecked] = React.useState(false)

  const currentUser = useCurrentUser()

  const { usersFilter, handleSetUsersFilter } = React.useContext(StrategyActionsBLContext)

  const name = pipe((user) => {
    if (user.firstName) {
      return generateUserName(user)
    }

    return user.description
  })(user)

  // methods
  const selectMember = () => setIsChecked(!isChecked)

  React.useEffect(() => {
    if (isChecked) {
      if (usersFilter.some((member) => member.id === user.id)) {
        return
      }

      handleSetUsersFilter([...usersFilter, user])
    }

    if (!isChecked) {
      const filteredMembers = usersFilter.filter((member) => member.id !== user.id)
      handleSetUsersFilter(filteredMembers)
    }
  }, [isChecked])

  React.useEffect(() => {
    if (usersFilter.some((member) => member.id === user.id)) {
      setIsChecked(true)
    }
  }, [])

  return (
    <Wrapper container alignItems={'center'} component={'label'} htmlFor={user.id}>
      <Avatar user={user} />
      <Name>{name}</Name>
      {currentUser.id === user.id && <span>(Me)</span>}
      <input type={'checkbox'} id={user.id} checked={isChecked} onChange={selectMember} />
      {isChecked && <CheckedIcon />}
    </Wrapper>
  )
}

export default Member
